import { browserSupportsWebAuthn } from "@simplewebauthn/browser";

//Checks if the current browser/device supports passkeys
export function browserSupportsPasskey(): boolean {
  return browserSupportsWebAuthn();
}
